import { type Heading } from "#app/components/commonElements/TableOfContents.tsx"

export function extractHeadingsFromMarkdown(content: string): Heading[] {
  const headings: Heading[] = []
  const lines = content.split(/\r?\n/) // Handle both \n and \r\n line endings
  
  lines.forEach(line => {
    const match = line.match(/^(#{1,3})\s+(.+?)(?:\s*\r?\s*$)/) // Handle optional trailing whitespace and line endings
    if (match) {
      const id = createIdFromText(match[2])
      const heading = 'h' + match[1].length
      const text = match[2].trim()
      headings.push({ id, heading, text })
    }
  })

  return headings
}

function createIdFromText(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^\wÀ-ÿ\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/--+/g, '-')
    .trim()
}